import React from "react";
import {TreeDOMHelper, TreeNodeHelper, TreeUtilities} from "./TreeHelper";
import Dict from "dict-lib";
import ReactDOM from "react-dom";
import {Button, Col, Modal, Row} from "react-bootstrap";
import stylesScNavbar from "../../navbar/ScNavbar.module.css";
import {Typeahead} from "react-bootstrap-typeahead";
import stylesSCTree from "../SCTree.module.css";
import BUtils from "../../../utilities/BaseUtilities";
import {SCCombo} from "../../combo/SCCombo";
import {userService} from "../../../_redux/authentication/services/user.services";
import {BulkUpdate} from "../../../corpora/TreeNavbarMenu";
import {LexemeEditingLevel, LexemeUtilities} from "../../../lexeme/page/editor/LexemeHelper";
import {Notifications} from "../../../utilities/DictUtilities";
import {LexemeNavigator} from "../../lexemeNavigator/LexemeNavigator";
import {AdministrationUtilities} from "../../../administration/AdministrationHelper";

export class TreeModalStrippingWords extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDocModal: false,
            selectedExternalService: {},
            externalServices: [],
            strippingWordsInfos: {
                status: 'stop',
                style: 'default',
                text: '',
                storedText: '',
                isServiceActive: false,
                storedMissingWords: '',
                missingWords: [],
            },
            serviceRecovered: false,
            originalHtml: '',
            externalApi: null
        };

        this.prefix = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_PREFIX');
    }

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const shouldUpdate = (typeof nextProps.showDocModal !== 'undefined' && nextProps.showDocModal !== this.state.showDocModal) ||
            (nextState.selectedExternalService !== this.state.selectedExternalService) ||
            (nextState.showDocModal !== this.state.showDocModal) ||
            /*(nextState.strippingWordsInfos.status !== this.state.strippingWordsInfos.status) ||*/
            (nextState.strippingWordsInfos !== this.state.strippingWordsInfos) ||
            (nextProps.originalHtml !== this.state.originalHtml);

        return shouldUpdate;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setState({showDocModal: prevProps.showDocModal, originalHtml: prevProps.originalHtml}, () => {
            if (!prevProps.showDocModal) {
                Dict.call('/tree/alignmentService/getScDictionariesByLang/' + this.props.projectName + '/' + this.props.doc.langCode + '/').then((result) => {
                    if (result.result === 'OK') {
                        const list = result.dicts;
                        var selectedExternalService = {};
                        if (list.length === 0) {
                            selectedExternalService = {apiName: Dict.t('EXTERNAL_DICTIONARY_NOT_FOUND')}
                        } else if (list.length === 1) {
                            selectedExternalService = list[0];
                        }

                        this.setState({
                            serviceRecovered: true,
                            /*selectedExternalService: list.length > 0 ? list[0] : {apiName: Dict.t('EXTERNAL_DICTIONARY_NOT_FOUND')},*/
                            externalServices: [{
                                value: Dict.t('CHOOSE'),
                                text: Dict.t('CHOOSE')
                            }].concat(list.map((item) => {
                                item.value = item.apiName;
                                item.text = item.apiName;
                                return item;
                            }))
                        }, () => {
                            if (Object.keys(this.state.selectedExternalService).length === 0)
                                this.setState({selectedExternalService}, () => {
                                    if (this.state.externalServices.length > 1)
                                        this._setStrippingProcess();
                                });

                        });
                    } else {
                        Notifications.showErrorModalMessage('ignore:' + Dict.t('EXTERNAL_DICTIONARY_ERROR'), 3000);
                    }
                })
            }
        })
    }

    _resetServiceSelection() {
        this.setState({selectedExternalService: {}});
    }

    _resetOriginalHtml() {
        document.getElementById('scrollable-document-container').innerHTML = this.state.originalHtml;
    }

    _resetStrippingProcess() {
        const strippingWordsInfos = {
            status: 'stop',
            style: 'default',
            text: '',
            storedText: '',
            isServiceActive: false,
            storedMissingWords: '',
            missingWords: [],
        }

        this.setState({strippingWordsInfos});
    }

    _setStrippingProcess() {
        if(Object.keys(this.state.selectedExternalService).length > 0) {
            const endPoint = escape(encodeURIComponent(JSON.stringify(this.state.selectedExternalService)));
            Dict.call('/tree/checkSavedMissingForms/' + this.props.projectName + '/' + this.props.item.key + '/' + this.props.doc.langCode + '/' + endPoint + '/').then((storedMissingWords) => {

                    const fileFound = Object.keys(storedMissingWords).length > 0;

                    const strippingWordsInfos = {
                        status: 'stop',
                        style: 'default',
                        storedStyle: 'default',
                        text: Dict.t(!fileFound ? 'STRIPPING_OF_WORDS' : 'RELAUNCH_STRIPPING_OF_WORDS'),
                        storedText: Dict.t(fileFound && storedMissingWords.errorInTextFound ? 'SHOW_STORED_MISSING_WORDS' : 'STRIPPING_WORDS_OK'),
                        isServiceActive: true,
                        missingWords: [],
                        storedMissingWords,
                        endPoint: this.state.selectedExternalService
                    };

                    this.setState({strippingWordsInfos})
                }
            )
        }
    }

    _close() {
        document.getElementById('node-page').style.opacity = 1;
        var doc = {
            filename: '',
            src: '',
            extension: '',
            pageNumber: 1,
            numbPages: -1,
            label: '',
            langCode: '',
            lang1: '',
            lang2: ''
        };
        this.setState({doc});
        this.props.callbackParentClose(true);
    }

    render() {
        const selectedExternalService = this.state.selectedExternalService;
        const serviceFound = typeof selectedExternalService.apiName !== 'undefined' && selectedExternalService.apiName !== Dict.t('EXTERNAL_DICTIONARY_NOT_FOUND');
        const dictName = typeof selectedExternalService.apiName !== 'undefined' ? selectedExternalService.apiName : '';
        const selectedExternalServiceChoosen = Object.keys(selectedExternalService).length > 0 && selectedExternalService.value !== Dict.t('CHOOSE');
        const moreThanOneServices = this.state.externalServices.length > 2;

        const strippingWordsInfos = this.state.strippingWordsInfos;
        //TODO dividere "chiudi" dagli altri e discriminare per service found

        return <Modal id='tree-modal-doc' show={this.state.showDocModal} className={stylesSCTree["tree-modal-doc"]}
                      backdrop={'static'}
                      dialogClassName={stylesSCTree['tree-modal-doc__dialog']}
                      onHide={() => this._close()} restoreFocus>
            <Modal.Header id={'tree-modal-doc-header'} className={stylesSCTree['tree-modal-doc__header']}/>
            <Modal.Body id={'tree-modal-doc-body'} className={stylesSCTree["tree-modal-doc__body"]}/>
            <Modal.Footer
                className={BUtils.joinClasses(stylesSCTree['tree-modal-doc__footer'], stylesSCTree['tree-modal-doc__footer__show--' + this.state.serviceRecovered])}>
                <Row
                    className={BUtils.joinClasses(stylesSCTree['additional-tree-modal-doc-footer-items__choose-service'], stylesSCTree['additional-tree-modal-doc-footer-items__choose-service-show--' + (this.state.externalServices.length > 0)])}>
                    <>
                        {this.state.serviceRecovered && !selectedExternalServiceChoosen ?
                            <>
                                <SCCombo options={this.state.externalServices}
                                         value={selectedExternalService}
                                         label={Dict.t('AVAILABLE_DICTIONARIES')}
                                         callbackParent={(newState) => {
                                             const newSelectedExternalService = this.state.externalServices.find((item) => {
                                                 return item.apiName === newState;
                                             });
                                             this.setState({selectedExternalService: newSelectedExternalService}, () => {
                                                 this._setStrippingProcess()
                                             });
                                         }}/>
                                {/*<Button
                                    onClick={() => {
                                        this._close();
                                    }}>{Dict.t('CLOSE')}</Button>*/}
                            </> : <div style={{marginRight: '10px', fontWeight: 'bold'}}>{dictName}</div>}
                    </>
                </Row>
                <Row
                    className={BUtils.joinClasses(stylesSCTree['additional-tree-modal-doc-footer-items__buttons'], stylesSCTree['additional-tree-modal-doc-footer-items__buttons-show--true' /*+ (selectedExternalServiceChoosen && strippingWordsInfos.isServiceActive)*/])}>
                    {serviceFound && (strippingWordsInfos.missingWords.length > 0 || (strippingWordsInfos.storedStyle === 'danger' && strippingWordsInfos.storedMissingWords.missingWords.length > 0)) ?
                        <Button id={'DOWNLOAD_TEXT_MISSING_WORDS'}
                                onClick={() => {
                                    const collection = strippingWordsInfos.missingWords.length > 0 ? strippingWordsInfos.missingWords : strippingWordsInfos.storedMissingWords.missingWords;
                                    var uniqueMissingWords = [...new Set(collection)].join('\n');

                                    const csvContent = "data:text/csv;charset=utf-8," + uniqueMissingWords;

                                    const encodedUri = encodeURI(csvContent);
                                    const link = document.createElement("a");
                                    link.setAttribute("href", encodedUri);
                                    link.setAttribute("download", this.state.strippingWordsInfos.endPoint.apiName + '_' + this.props.doc.langCode + '.csv');
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                        >
                            {Dict.t('DOWNLOAD_TEXT_MISSING_WORDS')}
                        </Button> : ''}
                    {serviceFound ? <Button id={'OPEN_SELECTED_STRIPPED_WORD'}
                                            onClick={() => {
                                                const getSelectionTextFromResult = (parentNodeId) => {
                                                    var text = '';
                                                    var selection = window.getSelection();
                                                    var parentNode = document.getElementById(parentNodeId);

                                                    if (selection.toString() && selection.anchorNode) {
                                                        var selectedNode = selection.anchorNode.parentNode;

                                                        if (parentNode.contains(selectedNode)) {
                                                            text = selection.toString();
                                                        }
                                                    }

                                                    return text;
                                                };


                                                //const alignmentDictionaryService = AdministrationUtilities.getAlignmentDictionaryService();
                                                const textToAdd = getSelectionTextFromResult('scrollable-document-container')
                                                //ReactDOM.unmountComponentAtNode(document.getElementById('row-entry-typeahead'));
                                                var navContainer = document.getElementById('lexeme-page-container');
                                                const closeNav = () => {
                                                    const cont = document.getElementById('lexeme-page-container')
                                                    cont.style.display = 'none';
                                                    ReactDOM.unmountComponentAtNode(cont);
                                                    cont.remove();
                                                }

                                                if (navContainer === null || navContainer.style.display === 'none') {
                                                    var divNavigator = document.createElement('div');
                                                    divNavigator.id = 'lexeme-page-container';
                                                    /*divNavigator.style.display = 'none';*/
                                                    divNavigator.className = stylesSCTree['alignment-html-text-navigator'];


                                                    if (this.state.strippingWordsInfos.endPoint !== 'not_found') {

                                                        var context = {
                                                            languageCode: this.props.doc.langCode,
                                                            externalApi: {
                                                                host: this.state.selectedExternalService.apiEndPoint,
                                                                name: this.state.selectedExternalService.apiName
                                                            }
                                                            /*externalApi: {
                                                                host: this.state.strippingWordsInfos.endPoint.apiEndPoint,
                                                                name: this.state.strippingWordsInfos.endPoint.apiName
                                                            }*/
                                                        };


                                                        const LexemeNav = textToAdd ? <LexemeNavigator
                                                            textToAdd={textToAdd}
                                                            textToTranslate={''}
                                                            /*textToTranslate={textToTranslate}*/
                                                            pageStatus={LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE}
                                                            activeCreate={true}
                                                            context={context}
                                                            closeButton={true}
                                                            callbackParent={() => {

                                                            }}
                                                            callbackParentClose={() => {
                                                                closeNav();
                                                            }}
                                                            callBackSave={(selectableItem) => {
                                                                if (selectableItem === textToAdd) {
                                                                    Dict.call('/tree/retrieveSaveMissingWords/' + this.props.projectName + '/').then((result) => {
                                                                        if (result.length > 0) {
                                                                            var folders = [];
                                                                            var titles = [];
                                                                            result.forEach((item) => {
                                                                                if (!item.blacklisted && item.word === selectableItem) {
                                                                                    const id = item.idDoc.replace(this.prefix, '');
                                                                                    folders.push(id);
                                                                                    titles.push(item.title);
                                                                                }
                                                                            })
                                                                            Dict.call('/tree/resetMissingWords/' + this.props.projectName + '/' + Dict.encodeUrl(JSON.stringify(folders)) + '/').then((result) => {
                                                                                var text = '<br>';
                                                                                this._setStrippingProcess();
                                                                                this._resetOriginalHtml();
                                                                                titles.forEach((title) => {
                                                                                    text += '<b>' + title + '</b><br>'
                                                                                })
                                                                                Notifications.showWarningToastNotification("Poiché è stato aggiunto il lemma <b><u>" + textToAdd + "</u></b> dal testo, le parole mancanti nei seguenti documenti verranno riaggiornate attraverso l'esecuzione della funzione <i>cerca parole mancanti</i> per la coppia di lingue <b><u>" + this.props.doc.lang1 + "/" + this.props.doc.lang2 + "</u></b>:<br>" + text);
                                                                            })
                                                                        }
                                                                    });
                                                                }
                                                            }}/> : <div
                                                            style={{
                                                                fontSize: '16px',
                                                                padding: '8px',
                                                                fontWeight: 'bold'
                                                            }}>{'testo selezionato non trovato'}</div>;
                                                        ReactDOM.render(LexemeNav, divNavigator);

                                                        document.getElementById('tree-modal-doc').appendChild(divNavigator);
                                                    } else {
                                                        Notifications.showErrorModalMessage('ALERT_INSERT_SC_DICTIONARY_NOT_FOUND', 2000);
                                                    }
                                                } else {
                                                    closeNav();
                                                }


                                            }}>{Dict.t('OPEN_SELECTED_TEXT_ON_NAVIGATOR')}</Button> : ''}
                    {serviceFound && this.state.strippingWordsInfos.storedStyle !== 'danger' ? <Button
                        disabled={this.state.strippingWordsInfos.status !== 'stop'}
                        bsStyle={this.state.strippingWordsInfos.style}
                        style={{width: '200px'}}
                        onClick={() => {
                            this._resetOriginalHtml();

                            var strippingWordsInfos = {
                                status: 'start',
                                style: 'warning',
                                text: Dict.t('STRIPPING_WORDS_IN_PROGRESS'),
                                isServiceActive: true,
                                storedMissingWords: '',
                                missingWords: [],
                                endPoint: this.state.strippingWordsInfos.endPoint
                            };
                            this.setState({strippingWordsInfos})

                            const docNum = this.props.doc.langCode === this.props.doc.lang1 ? '1' : '2';

                            Dict.call('/tree/checkMissingForms/' + this.props.projectName + '/' + this.props.item.key + '/' + docNum + '/' + this.props.doc.langCode + '/' + LexemeUtilities.encodeUrl(JSON.stringify(this.state.strippingWordsInfos.endPoint)) + '/').then((result) => {
                                if (result.result === 'OK') {
                                    strippingWordsInfos = {
                                        status: 'finished',
                                        style: (result.errorInTextFound === 'false' ? 'success' : 'danger'),
                                        text: Dict.t(result.errorInTextFound === 'false' ? 'STRIPPING_WORDS_OK' : 'STRIPPING_WORDS_FOUND'),
                                        missingWords: result.missingWords,
                                        isServiceActive: true,
                                        storedMissingWords: '',
                                        endPoint: this.state.strippingWordsInfos.endPoint
                                    };
                                    this.setState({strippingWordsInfos})

                                    const html = result.html.replaceAll("&lt;", "<").replaceAll("&gt;", ">");

                                    document.getElementById('scrollable-document-container').innerHTML = html;
                                } else {
                                    strippingWordsInfos = {
                                        status: 'finished',
                                        style: (result.errorInTextFound === 'false' ? 'success' : 'danger'),
                                        text: Dict.t("STRIPPING_WORDS_ERROR_PROCESSING"),
                                        missingWords: [],
                                        isServiceActive: true,
                                        endPoint: this.state.strippingWordsInfos.endPoint
                                    };
                                    this.setState({strippingWordsInfos}, () => {
                                        setTimeout(() => {
                                            this._setStrippingProcess();
                                        }, 3000)
                                    });
                                }
                            })
                        }}
                    >{this.state.strippingWordsInfos.text}</Button> : ''}
                    {serviceFound && this.state.strippingWordsInfos.storedMissingWords !== '' ? <Button
                        bsStyle={this.state.strippingWordsInfos.storedStyle}
                        disabled={this.state.strippingWordsInfos.status !== 'stop'}
                        onClick={() => {
                            var strippingWordsInfos = BUtils.cloneJson(this.state.strippingWordsInfos);

                            strippingWordsInfos.status = 'finished';
                            strippingWordsInfos.storedStyle = (this.state.strippingWordsInfos.storedMissingWords.errorInTextFound === 'false' ? 'success' : 'danger');
                            strippingWordsInfos.storedText = Dict.t(this.state.strippingWordsInfos.storedMissingWords.errorInTextFound === 'false' ? 'STRIPPING_WORDS_OK' : 'STRIPPING_WORDS_FOUND');
                            strippingWordsInfos.isServiceActive = true;

                            const html = this.state.strippingWordsInfos.storedMissingWords.html.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
                            document.getElementById('scrollable-document-container').innerHTML = html;

                            this.setState({strippingWordsInfos});

                        }}>
                        {this.state.strippingWordsInfos.storedText}
                    </Button> : ''}
                    {serviceFound && moreThanOneServices ? <Button
                        onClick={() => {
                            this._resetStrippingProcess();
                            this._resetOriginalHtml();
                            this._resetServiceSelection();
                        }}
                    >{Dict.t('CHOOSE_DICTIONARY')}
                    </Button> : ''}
                    {serviceFound ? <Button
                        onClick={() => {
                            this._setStrippingProcess();
                            this._resetOriginalHtml();
                        }}
                    >{Dict.t('RESET')}
                    </Button> : ''}
                    <Button
                        onClick={() => {
                            this._close();
                        }}>{Dict.t('CLOSE')}</Button>
                </Row>
            </Modal.Footer>
        </Modal>
    }
}